export default {
  baseUrl: 'http://calmoslegacytest1-env.eba-jppmvjjm.eu-central-1.elasticbeanstalk.com',
  notificatorUrl: 'https://localhost:8000',
};
